/**
 * Created by Pavel Vorobev on 01.04.15.
 */

lmApp
  .controller('SuperuserController', ['$kookies', '$q', '$scope', '$rootScope', '$timeout', '$templateCache', '$compile', 'SuperuserSrv', 'ProfileService',
    function ($kookies, $q, $scope, $rootScope, $timeout, $templateCache, $compile, SuperuserSrv, ProfileService) {
      $scope.operators = [];
      $scope.currentId = $rootScope.currentOperator.id;
      $scope.loading = false;
      $scope.search = {};

      $scope.isOperatorSelected = function () {
        return $rootScope.globals && $rootScope.globals.currentUser && !!$rootScope.globals.currentUser.operatorToken;
      };

      //Set up original admin token to get access to admin features.
      $scope.returnToGod = function () {
        if ($scope.loading) {
          return;
        }

        $scope.currentId = '';
        $rootScope.currentOperator.id = '';
        $rootScope.currentOperator.title = '';
        $rootScope.currentOperator.company_name = '';
        $rootScope.currentOperator.accounts = [];
        $rootScope.currentOperator.projectName = '';

        $rootScope.globals.currentUser.company_name = '';
        $rootScope.globals.currentUser.accounts = [];
        $rootScope.globals.currentUser.operatorId = '';
        $rootScope.globals.currentUser.operatorName = '';
        $rootScope.globals.currentUser.projectName = '';
        $rootScope.globals.currentUser.operatorToken = null;
        $kookies.set('globals', JSON.stringify($rootScope.globals), {path: '/', expires: 7});

        $rootScope.showLinearProgress('#adminLoader');
        $scope.loading = true;

        lh.common.config.set({authToken: $rootScope.globals.currentUser.supervisorToken});

        SuperuserSrv.GetOperators()
          .then(function (response) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#adminLoader');
            $scope.operators = _.get(response, 'data.data', []);
          }, function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#adminLoader');
          });
      };

      $scope.viewOperator = function (operator) {
        SuperuserSrv.GetAccessToken(operator)
          .then(function (response) {
            $rootScope.globals.currentUser.operatorToken = _.get(response, 'data.data');

            lh.common.config.set({authToken: _.get(response, 'data.data')});
            lh.system.init();

            ProfileService.GetOperatorData()
              .then(function (data) {
                var operator = _.get(data, 'operator');

                if (!operator) {
                  throw '';
                }

                $rootScope.currentOperator.id = operator.id;

                $rootScope.globals.currentUser.operatorId = operator.id;
                $rootScope.globals.currentUser.project = operator.name;

                localStorage['accounts'] = JSON.stringify(operator.accounts || []);

                $rootScope.globals.currentUser.company_name = operator.company_name;
                $rootScope.globals.currentUser.operatorName = operator.name;
                $rootScope.globals.currentUser.projectName = '';

                $rootScope.currentOperator.title = operator.name;
                $rootScope.currentOperator.accounts = operator.accounts;
                $rootScope.currentOperator.company_name = operator.company_name;
                $rootScope.currentOperator.projectName = '';

                $rootScope.globals.currentUser.projectName = operator.title;
                $rootScope.currentOperator.projectName = operator.title;

                $kookies.set('globals', JSON.stringify($rootScope.globals), {path: '/', expires: 7});

                $rootScope._self = operator;
                $timeout(function () {
                  $rootScope.$broadcast('self:update', operator)
                }, 350);

                $rootScope.go('/profile');
              }, function (reason) {

                $kookies.set('globals', JSON.stringify($rootScope.globals), {path: '/', expires: 7});

                $rootScope.go('/profile');
              });
          });
      };

      if (!$scope.isOperatorSelected()) {
        SuperuserSrv.GetOperators()
          .then(function (response) {
            $rootScope.hideLinearProgress('#adminLoader');

            $scope.operators = _.get(response, 'data.data', []);
          });
      }
    }]);
